import React, { Component } from 'react';
import './App.scss';

import Nav from './Nav';
import Story from './Story';
import STORIES from './Story.const';

import headerTitle from './assets/images/header_title.png';
import headerImage from './assets/images/headerimage.jpg';
import playButton from './assets/images/top_playbutton.jpg';
import pauseButton from './assets/images/top_pausebutton.jpg';

if(window.location.pathname.substr(-1) == '/'){
	var root = window.location.pathname;
}else{
	var root = window.location.pathname+'/';
}
export const APP_ROOT_PATH = root;
//export const APP_ROOT_PATH = '/theheartseekers/';

class App extends Component {
  constructor(props) {
    super(props);

    const language = this.getLanguage();

    this.state = {
      language,
      activeAudioIndex: undefined
    };

    if (!language === '' || !this.isValidLanguage(language)) {
      window.location.href = `${APP_ROOT_PATH}/zh-HK`;
      return;
    }

    this.players = [];
    for (const _ of STORIES) {
      this.players.push(undefined);
    }
  }

  getLanguage = () => {
    let language = 'zh-HK';
    const { match } = this.props;
    /*if (match && match.params && match.params.language) {
      language = match.params.language;
    }*/
	if (match && match.url && match.url.split("/").pop() == 'en') {
      language = 'en';
    }else if (match && match.url && match.url.split("/").pop() == 'zh-hk') {
	  language = 'zh-HK';
	}
    return language;
  };

  isValidLanguage = language => {
    return ['en', 'zh-HK'].includes(language);
  };

  handlePlayClick = index => {
    const { players, pausePlayer } = this;
    const { activeAudioIndex } = this.state;

    if (activeAudioIndex !== undefined) {
      // pause playing audio
      pausePlayer(activeAudioIndex);
    }

    if (activeAudioIndex !== index) {
      // play selected audio
      let newPlayer = players[index];
      if (!newPlayer) {
        const soundTrack =
          this.getLanguage() === 'en'
            ? STORIES[index].soundTrackEN
            : STORIES[index].soundTrack;
        newPlayer = new Audio(soundTrack);
        newPlayer.addEventListener('ended', () => {
          this.setState({ activeAudioIndex: undefined });
        });
        players[index] = newPlayer;
      }
      newPlayer.play();
      this.setState({ activeAudioIndex: index });
    } else {
      // pause current audio
      this.setState({ activeAudioIndex: undefined });
    }
  };

  handlePlayIntroductionClick = () => {
    this.handlePlayClick(0);
  };

  pausePlayer = index => {
    const { players } = this;
    const oldPlayer = players[index];
    oldPlayer && oldPlayer.pause();
  };

  render() {
    const { handlePlayClick, handlePlayIntroductionClick } = this;
    const { language, activeAudioIndex } = this.state;

    return (
      <div className="wrapper">
        <Nav language={language}/>
        <header className="page-header">
		 <>
			<img src={headerImage} alt="Alone Together 2022"/>
			 </>
        </header>
        <section className="description">
          {language !== 'en' && (
            <>
              <p>
              三年前，Mateusz Kolek 以「Alone Together」為題在香港舉辦的個人展覽大受歡迎，當時展出的 “Things I’ve Seen But I Didn’t Have A Smartphone” 畫作系列，紀錄了他眼中光怪陸離的香港。事隔三年後，再次「Alone Together」為主題，名字相同，背後的意義早已截然不同。
</p>
              <p>
「Alone Together 2022」分為兩部份：除了由 ZtoryTeller 策展的香港部份外，「Alone Together 2022」亦於 8 月尾在波蘭克拉科夫市舉行，由藝術家 @mateusz_kolek 策展 —— 透過兩地同步舉行展覽：縱使城市與城市之間被逼隔離，仍無阻藝術連結香港和波蘭兩地。
</p>
              <p>
從構思到實行，那是一個很漫長的旅程。終於，隨著作品集於網站上架，展覽也將於本週日 8月14日正式開始。
</p>
              <p>
面對疫情，人與人之間的距離變得更遠，世界亦不再一樣，但當人人都處於隔離狀態，我們同時找到新的方式互相連結。ZtoryTeller跟Mateusz最後一次見面是在東京，那時候一起參與當地聯展，離開東京後，世界各地隨即進入封鎖狀態。 也因此，Mateusz 首本個人作品集《Alone Together》，以香港、日本及波蘭三地為主題，紀錄了世界變化前和變化後的面貌。
</p>
            </>
          )}
          {language == 'en' && (
            <>
               <p>
              "Alone Together 2022" is divided into two parts: In addition to the Hong Kong part curated by Ztory Teller, "Alone Together 2022" will be also held in Krakow, Poland at the end of August, curated by artist @mateusz_kolek - through the bi-city exhibition in different places, there is no obstacle to connect Hong Kong and Poland through art.
</p>
              <p>
From conception to implementation, it was a long journey. Finally, with the collection of works on the website, the exhibition will officially start this Sunday, August 14th.
</p>
              <p>
Mateusz's first solo collection "Alone Together", with the theme of Hong Kong, Japan and Poland, records the appearance of the world before and after the change.
</p>
            </>
          )}
        </section>
        <section className="journey">
		 {language !== 'en' && (
		 <>
		  <p className="performed">Audio guide performed by Chan Kin Long</p>
		  </>
		 )}
		 {language == 'en' && (
            <>
		  <p className="performed">Audio guide performed by Sabrina Cheung</p>
		  </>
		  )}
          <h2>Start Imagining</h2>
          <div className="stories">
            {STORIES.map((story, index) => {
              const { title, subTitle, imageSrc, desc, descEN } = story;

              return (
                <Story
                  key={index}
                  index={index}
                  title={title}
                  subTitle={subTitle}
                  desc={this.getLanguage()=='en'?descEN:desc}
                  imageSrc={imageSrc}
                  onPlayClick={handlePlayClick}
                  isPlaying={activeAudioIndex === index}
                />
              );
            })}
          </div>
		  <section class="description">
		  </section>
		  {language !== 'en' && (
		 <>
		  <div className="thanks">Audio guide performed by Chan Kin Long</div>
		  </>
		 )}
		 {language == 'en' && (
            <>
		  <div className="thanks">Audio guide performed by Sabrina Cheung</div>
		  </>
		  )}
        </section>
      </div>
    );
  }
}

export default App;
